import { subdomains } from "@/common/consts";
import SentencesHome from "@/pages/Sentences/Home/SentencesHome.vue";
import SentenceDetail from "@/pages/Sentences/Detail/SentenceDetail.vue";
import SentenceIndex from "@/pages/Sentences/Index/SentenceIndex.vue";
import ExperimentOverride from "@/pages/ExperimentOverride/ExperimentOverride.vue";

export default [
    {
        path: "/",
        name: "Sentences",
        meta: {
            subdomain: subdomains.SENTENCES
        },
        component: SentencesHome
    },
    {
        path: "/abexp/:channel?",
        name: "ExperimentOverride",
        component: ExperimentOverride
    },
    {
        path: "/:slug",
        name: "SentencesDetail",
        meta: {
            subdomain: subdomains.SENTENCES
        },
        props: true,
        component: SentenceDetail
    },
    {
        path: "/index/:index",
        name: "SentencesIndex",
        meta: {
            subdomain: subdomains.SENTENCES
        },
        props: true,
        component: SentenceIndex
    }
];



// WEBPACK FOOTER //
// ./src/router/routes/subdomain.sentence.js